export default "__VITE_ASSET__bcc295bc__"